import React, { FC } from 'react';
import { Stack } from '@mui/material';
import { RequiredAsterisk, StyledGrid,StyledLabel, StyledStack, StyledSubLabel } from 'components/GridItem/styled';
import { GridItemProps } from 'components/GridItem/types';

const GridItem: FC<GridItemProps> = ({ label, required, children, sublabel, ...rest }) => {
  return (
    <StyledGrid item md={12} lg={12} {...rest} sx={{ maxWidth:'300px'}}>
      {label || sublabel ? (
        <StyledLabel>
          <StyledStack direction='row'>
            <Stack direction='row'>
              {label}
              {required && <RequiredAsterisk>*</RequiredAsterisk>}
            </Stack>
            <Stack>
              {sublabel && <StyledSubLabel>{sublabel}</StyledSubLabel>}
            </Stack>
          </StyledStack>
        </StyledLabel>
      ) : null}

      {children}
    </StyledGrid>
  );
};

export default GridItem;
